import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ESourceTypes, EVerificationOpenForm, IArbitrageForm, IBloggerForm, IWebsiteForm } from 'entities/Source';

interface ISourceSlice {
	verificationOpenFrom: EVerificationOpenForm;
	type: ESourceTypes;
	websiteValues: IWebsiteForm;
	bloggerValues: IBloggerForm;
	bloggerUrls: Record<string, string[]>;
	arbitrationValues: IArbitrageForm;
}

const initialState: ISourceSlice = {
	verificationOpenFrom: '' as EVerificationOpenForm,
	type: '' as ESourceTypes,
	websiteValues: {
		name: '',
		url: '',
		platform_type: null,
		countries: [],
		content_themes: [],
		extension_exists: false,
		extension_description: '',
	},
	bloggerValues: {
		name: '',
		platform_types: [],
		countries: [],
		content_themes: [],
	},
	bloggerUrls: {},
	arbitrationValues: {
		name: '',
		purchase_type: null,
		url1: '',
		url2: '',
		url3: '',
		url4: '',
		url5: '',
		urls: ['1'],
		countries: [],
		description: '',
		screenshots: [],
	},
};

export const sourceSlice = createSlice({
	name: 'source',
	initialState,
	reducers: {
		setVerificationOpenFrom: (state, action: PayloadAction<EVerificationOpenForm>) => {
			state.verificationOpenFrom = action.payload;
		},
		setType: (state, action: PayloadAction<ESourceTypes>) => {
			state.type = action.payload;
		},
		setWebsiteValues: (state, action: PayloadAction<IWebsiteForm>) => {
			state.websiteValues = action.payload;
		},
		setBloggerValues: (state, action: PayloadAction<IBloggerForm>) => {
			state.bloggerValues = action.payload;
		},
		setBloggerUrls: (state, action: PayloadAction<{ key: string; value: string[] }>) => {
			state.bloggerUrls[action.payload.key] = action.payload.value;
		},
		setAllBloggerUrls: (state, action: PayloadAction<Record<string, string[]>>) => {
			state.bloggerUrls = action.payload;
		},
		setArbitrationValues: (state, action: PayloadAction<IArbitrageForm>) => {
			state.arbitrationValues = action.payload;
		},

		clearValues: (state) => {
			state.type = initialState.type;
			state.websiteValues = initialState.websiteValues;
			state.bloggerValues = initialState.bloggerValues;
			state.bloggerUrls = initialState.bloggerUrls;
			state.arbitrationValues = initialState.arbitrationValues;
		},
	},
});

export default sourceSlice.reducer;
export const {
	setVerificationOpenFrom,
	setType,
	setWebsiteValues,
	setBloggerValues,
	setBloggerUrls,
	setAllBloggerUrls,
	setArbitrationValues,
	clearValues,
} = sourceSlice.actions;
